import React, { Suspense, lazy } from "react";
import * as Sentry from "@sentry/browser";
import useGrayStrategy from "../../hooks/useGrayStrategy";
import { GRAY_FLAG } from "../../config";
import ErrorBoundary from "../../components/ErrorBoundary";
import LoadingHomepage from "../maintence/components/LoadingHomepage";
// 旧版预约（线上稳定基线）
import Reservation from "../reservation";

// 新版预约（灰度命中）——懒加载，灰度未启用时不进入首屏包体
const ReservationV2 = lazy(() => import("../reservationV2"));

/**
 * 预约入口灰度分流：
 * - 命中灰度                → 新版 reservationV2
 * - 未命中 / 灰度接口报错   → 旧版 reservation（错误兜底回旧版）
 * - 新版 chunk 加载失败     → ErrorBoundary 回落旧版（并 Sentry 上报）
 */
export default function ReservationEntry() {
  const { isLoaded, isGray } = useGrayStrategy(GRAY_FLAG);

  // 灰度判断中：首屏 loading
  if (!isLoaded) {
    return <LoadingHomepage />;
  }

  // 命中灰度：新版；若新版 chunk 加载失败，由 ErrorBoundary 回落旧版
  if (isGray) {
    return (
      <ErrorBoundary
        onError={(error) => Sentry.captureException(error)}
        fallback={<Reservation />}
      >
        <Suspense fallback={<LoadingHomepage />}>
          <ReservationV2 />
        </Suspense>
      </ErrorBoundary>
    );
  }

  // 未命中 / 灰度接口报错 → 旧版
  return <Reservation />;
}
